module.exports = __webpack_public_path__ + "img/AKB-logo 1080.4ed19e96.png";